import React, { useState } from 'react';

import Dropdown from 'react-bootstrap/Dropdown';
import { faUserCircle, faBars } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image';

import ROUTES from "utils/routes"
import SignOutButton from 'components/firebase/SignOut';
import { useAuthentication } from 'components/firebase/AuthUserContext';

import "./navbarLaser.scss";

type NavBarPropTypes = {
  background?: 'light' | 'dark' | 'transparent',
}

const ProfileDropdown = () => {
  const authUser = useAuthentication()

  return (
    <Dropdown className="login-container">
      <Dropdown.Toggle as={CustomToggle}></Dropdown.Toggle>

      {authUser ? <NavigationAuth /> : <NavigationNonAuth />}
    </Dropdown>
  )
}

const CustomToggle = React.forwardRef(({ onClick }, ref) => (
  <span
    ref={ref}
    onClick={e => {
      e.preventDefault();
      onClick(e);
    }}
  >
    <FontAwesomeIcon  id="account-icon" icon={faUserCircle}/>
  </span>
));

const NavigationAuth = () => (
  <Dropdown.Menu className="login-menu">
    <Dropdown.Item><Link to={ROUTES.ACCOUNT}>Account</Link></Dropdown.Item>
    <Dropdown.Item><SignOutButton/></Dropdown.Item>
  </Dropdown.Menu>
);

const NavigationNonAuth = () => (
  <Dropdown.Menu className="login-menu">
    <Dropdown.Item><Link to={ROUTES.SIGN_IN}>Sign In</Link></Dropdown.Item>
  </Dropdown.Menu>
);


const NavbarLaser = (props: NavBarPropTypes) => {
  const {
    background = 'dark',
  } = props
  const navBarCss = `nav_bar_${background}`
  const [showMenu, setShowMenu] = useState<boolean>(false)
  const onClick = () => setShowMenu(!showMenu);

  return (
    <nav
        className={navBarCss}
    >
      <div id="logo-container">
          <Link to={ROUTES.LANDING}><StaticImage src="../../images/refactor/LaserLogo.svg" alt="logo" style={{width: "40px"}}/></Link>
          <span id="brand" className="desktop-brand"><Link to={ROUTES.LASER_DATA}><b>LASER:</b> Lobbyist Aggregation & Structured Entity Resolution</Link></span>
          <span id="brand" className="mobile-brand"><Link to={ROUTES.LASER_DATA}><b>LASER</b> Lobbyist Data</Link></span>
      </div>
      <div className="routing-container">
        <div className="desktop-menu">
          <Link to={ROUTES.LANDING}>LobbyView Home</Link>
          <Link to={ROUTES.ABOUT}>About</Link>
          <Link to={ROUTES.DATA_DOWNLOAD}>Data Download</Link>
        </div>
        <ProfileDropdown />
        <FontAwesomeIcon id="menu-icon" icon={faBars} onClick={onClick}/>
        <div id="collapsable-menu" className={showMenu ? 'show' : 'hide'}>
          <Link to={ROUTES.LANDING}>LobbyView Home</Link>
          <Link to={ROUTES.ABOUT}>About</Link>
          <Link to={ROUTES.DATA_DOWNLOAD}>Data Download</Link>
        </div>
      </div>

    </nav>
  )
}
export default NavbarLaser
